/* VH scroll-reveal: curated targets fade-and-rise as they enter the viewport,
   staggered within their parent group. No-ops for reduced-motion users, and all
   content stays fully visible when JS is unavailable. */
(function () {
  "use strict";
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (!("IntersectionObserver" in window)) return;

  var GROUPS = [
    ".vhx-eyebrow", ".vhx-h2", ".vhx-lead",
    ".vh-bgrid__cell", ".vh-step", ".vhx-ritual-step",
    ".vh-cost__card", ".vh-proof__card", ".vh-scis__stat",
    ".vh-lpc__row", ".vh-lpc__foot",
    ".vhx-explorer-tabs", ".vhx-explorer-panel-inner",
    ".vhx-compare-scroll", ".vhx-table-scroll",
    ".vh-ctab__media", ".vh-ctab__body",
    ".vh-review-card", ".vh-acc",
    ".vhx-guarantee-block", ".vh-ft__giant", ".vhx-cta-pill", ".vhx-compare-cta"
  ];
  var els = document.querySelectorAll(GROUPS.join(","));
  var groupIndex = new Map();
  els.forEach(function (el) {
    // Above-the-fold content should never start hidden.
    if (el.getBoundingClientRect().top < window.innerHeight * 0.8) return;
    var parent = el.parentElement;
    var i = groupIndex.get(parent) || 0;
    groupIndex.set(parent, i + 1);
    el.style.setProperty("--vhr-d", (Math.min(i, 5) * 90) + "ms");
    el.classList.add("vh-reveal");
    if (el.matches(".vh-ctab__media, .vhx-compare-scroll, .vhx-table-scroll")) el.classList.add("vh-reveal--scale");
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add("is-in");
      io.unobserve(e.target);
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
  document.querySelectorAll(".vh-reveal").forEach(function (el) { io.observe(el); });
})();
